import { __decorate } from 'tslib';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Platform as Platform$1 } from '@angular/cdk/platform';
import { ɵɵdefineInjectable, ɵɵinject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/cdk/platform';
import * as ɵngcc2 from '@angular/cdk/layout';
let Platform = class Platform {
    constructor(
    // Dependencies
    cdkPlatform, breakpointObserver) {
        this.cdkPlatform = cdkPlatform;
        this.breakpointObserver = breakpointObserver;
        // Whether the main input device is not a hover device.
        // Typically this means it's a touch devices.
        this.touchIsMainInput$ = new BehaviorSubject(false);
        // Copying these values from the Angular CDK's Platform object, rather
        // than using the CDK's service directly, in case we eventually need to
        // change the detection implementation.
        this.isBrowser = this.cdkPlatform.isBrowser;
        this.isAndroid = this.cdkPlatform.ANDROID;
        this.isIOS = this.cdkPlatform.IOS;
        this.isBlink = this.cdkPlatform.BLINK;
        this.isWebkit = this.cdkPlatform.WEBKIT;
        this.isEdge = this.cdkPlatform.EDGE;
        this.isFirefox = this.cdkPlatform.FIREFOX;
        this.isSafari = this.cdkPlatform.SAFARI;
        this.platformTokensBS$ = new BehaviorSubject([
            this.isAndroid && 'android',
            this.isIOS && 'ios',
            this.isBlink && 'blink',
            this.isWebkit && 'webkit',
            this.isEdge && 'edge',
            this.isFirefox && 'firefox',
            this.isSafari && 'safari',
        ]
            .filter(v => v));
        this.platformTokens$ = this.platformTokensBS$.asObservable();
        this.breakpointObserver.observe('(hover: none)')
            .subscribe((breakpointState) => this.touchIsMainInput$.next(breakpointState.matches));
        document.documentElement.classList.add(...this.platformTokensBS$.value);
        document.body.classList.add(...this.platformTokensBS$.value);
    }
};
Platform.ɵfac = function Platform_Factory(t) { return new (t || Platform)(ɵngcc0.ɵɵinject(ɵngcc1.Platform), ɵngcc0.ɵɵinject(ɵngcc2.BreakpointObserver)); };
Platform.ctorParameters = () => [
    { type: Platform$1 },
    { type: BreakpointObserver }
];
Platform.ɵprov = ɵɵdefineInjectable({ factory: function Platform_Factory() { return new Platform(ɵɵinject(Platform$1), ɵɵinject(BreakpointObserver)); }, token: Platform, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Platform, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.Platform }, { type: ɵngcc2.BreakpointObserver }]; }, null); })();

/*
 * Public API Surface of angular-platform
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Platform };

